import React from "react";
import AnalyticsView from "../components/AnalyticsView";
import { BarChart3 } from "lucide-react";

export default function Analytics() {
  return (
    <div className="space-y-6 lg:space-y-8" data-testid="analytics-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
        <div>
          <div className="font-mono text-[10px] sm:text-xs uppercase tracking-widest text-[#4A4A4A] flex items-center gap-2">
            <BarChart3 size={12}/> Reports
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black uppercase tracking-tight">Analytics</h1>
          <p className="font-mono text-xs sm:text-sm text-[#4A4A4A] mt-2 max-w-2xl">
            Slice your sales by any date range. See what's selling, who's selling it, and which shows pay best.
          </p>
        </div>
      </div>
      <AnalyticsView title="All sales" defaultRange="30d" />
    </div>
  );
}
